import { computed, toValue, type ComputedRef, type MaybeRefOrGetter } from "vue";
import {
  resolveBrandConfig,
  type BrandConfig,
} from "@dashboard/brands/brandConfig";

export type {
  BrandBssBinding,
  BrandBssKeys,
  BrandConfig,
  BrandConfigRecord,
  FooterLink,
} from "@dashboard/brands/brandConfig";
export {
  BRAND_CONFIGS,
  DEFAULT_BRAND_LOCALES,
  resolveBrandConfig,
} from "@dashboard/brands/brandConfig";

/**
 * Resolves dashboard settings for a brand and tracks a reactive brand key.
 * @remarks Migration: Replaces subclass property overrides with a shared typed config.
 * Keys are trimmed and lowercased; unknown or empty keys resolve to the RC config.
 * @param brand - Brand key, supplied directly or through a reactive ref or getter.
 * @returns Computed settings for the resolved brand.
 */
export function useBrandConfig(brand: MaybeRefOrGetter<string>): ComputedRef<BrandConfig> {
  return computed(() => resolveBrandConfig(toValue(brand)));
}
